'use strict';
moduleConfig.registerModule('eclipseApp.cfa', ['eclipseApp.core']);
